//0 Normal 1-8 A-H and >8 Normal
export const covertPositionNumberToChar = (positionNumber) => {
  if (positionNumber === null || positionNumber === undefined) return "";
  if (positionNumber === 0) return "Normal";
  if (positionNumber > 8) return "Normal";
  return String.fromCharCode(64 + positionNumber);
};
